// src/core/calculator.js

function round(n) {
  return Math.round(n * 100) / 100;
}

export function calculateFromNet(net, rate) {
  const ht = round(net);
  const vat = round(ht * rate / 100);
  const ttc = round(ht + vat);
  return { ht, vat, ttc };
}

export function calculateFromGross(ttc, rate) {
  const gross = round(ttc);
  if (rate === 0) return { ht: gross, vat: 0, ttc: gross };
  const ht = round(gross / (1 + rate / 100));
  const vat = round(gross - ht);
  return { ht, vat, ttc: gross };
}
